import { render, staticRenderFns } from "./dem1.vue?vue&type=template&id=94f22094&scoped=true&"
import script from "./dem1.vue?vue&type=script&lang=js&"
export * from "./dem1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f22094",
  null
  
)

export default component.exports